// src/shared-components/forms/add-board-content/add-post/inside-header/components/SavePostDraft.jsx
import { useEffect, useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import Text from '@/shared-components/text/components/Text';

/**
 * Inline Save-Draft button for post editor.
 * - formState: current post form state
 */
export default function SavePostDraft({
  formState,
  hasContent,
  initialStateRef,
  savePost
}) {
  const t = useTranslations('common.forms.board_editor');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);

  const hasChanges = JSON.stringify(formState) !== JSON.stringify(initialStateRef.current);
  // Clear “Saved!” after 2s
  useEffect(() => {
    if (success) {
      const t = setTimeout(() => setSuccess(false), 2000);
      return () => clearTimeout(t);
    }
  }, [success]);

  useEffect(() => {
    if (hasChanges && success) setSuccess(false);
  }, [hasChanges, success]);

  async function saveDraft() {
    if (!hasContent || !hasChanges || loading) return;
    setLoading(true);

    const result = await savePost();

    setLoading(false);
    if (result?.response?.ok) {
      setSuccess(true);
    }
  }

  const label = success ? t('saved') : t('save');

  const disabled = !hasContent || !hasChanges || loading;

  return (
    <Text
      className={[
        `board-header__item save-draft ${disabled ? 'disabled' : ''} ${success ? 'read-only' : ''}`,
        "font-size-medium"
      ].filter(Boolean).join(" ")}
      onClick={disabled ? undefined : saveDraft}>
      {label}
    </Text>
  );
}
